import React from 'react'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'

// Utils
import analytics from 'app/views/utils/analytics'

// Redux
import { generateQuiz } from 'app/state/modules/quiz'


class QuizOverview extends React.Component {
  componentDidMount() {
    analytics.page('quiz-overview')
    if (this.props.isAuthenticated) {
      this.props.generateQuiz()
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.isAuthenticated && nextProps.quiz.uuid) {
      this.props.history.push(`/quiz/${nextProps.quiz.uuid}`)
    }
  }

  render() {
    return (
      <div data-test-id="quiz-overview-component">
        <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-bottom uk-padding-remove-top uk-light">
          <div className="uk-section uk-padding-remove-top uk-text-center">
            <img src="/static/icons/test.png" style={{ height: 100 }} alt="test icon" />
            <h2>Free Secure Coding IQ Assessment</h2>
            <p className="uk-text-bold">
              Hands-On Secure Coding IQ Assessment
            </p>
            <p>
              What is your Application Security risk?
              <br />
              Do you need Secure Coding Training?
              <br />
              Assess your team, get the score, and find out now!
            </p>
            {(this.props.isAuthenticated && this.props.quiz.uuid) ? (
              <div>
                <Link to={`/quiz/${this.props.quiz.uuid}`} className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-right uk-margin-small-top">
                  Take the Assessment
                </Link>
                <Link to={`/quiz/${this.props.quiz.uuid}/results`} className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-right uk-margin-small-top">
                  Get Your Free Team Evaluation
                </Link>
              </div>
            ) : (
              <div>
                <Link data-test-id="take-the-test-btn" to="/quiz/take-the-test" className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-right uk-margin-small-top">
                  Take the Assessment
                </Link>
                <Link data-test-id="get-free-evaluation-btn" to="/register" className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large uk-margin-small-top">
                  Get Your Free Team Evaluation
                </Link>
              </div>
            )}
          </div>
        </div>

        <div className="uk-container">
          <div className="uk-section uk-padding-large uk-text-center">
            <div className="uk-grid uk-child-width-1-3@m" data-uk-grid>
              <div>
                <img className="uk-text-center" src="/static/icons/test.png" style={{ height: 100 }} alt="test icon" />
                <h3 className="uk-text-center uk-margin-small-top">Secure Coding IQ Assessment</h3>
                <p>
                  The Secure Coding IQ Assessment is a hands-on assessment covering the Open Web
                  Application Security Project (OWASP) Top 10 vulnerabilities.
                </p>
                <p>
                  These are the 10 most critical web application security risks and are often
                  responsible for the largest security breaches. All developers should know how to
                  protect against these otherwise your applications are at risk.
                </p>
              </div>
              <div>
                <img className="uk-text-center" src="/static/icons/question.png" style={{ height: 100 }} alt="question icon" />
                <h3 className="uk-text-center uk-margin-small-top">Why Your Developers Should Take the Assessment?</h3>
                <p>
                  Assess your teams Secure Coding knowledge.
                </p>
                <p>
                  This assessment can give you an idea if you have the right resources in place for
                  Application security.
                </p>
                <p>
                  See your team's score and compare it to industry average.
                </p>
              </div>
              <div>
                <img className="uk-text-center" src="/static/icons/money.png" style={{ height: 100 }} alt="money icon" />
                <h3 className="uk-text-center uk-margin-small-top">Need a bigger budget?</h3>
                <p>
                  Invite your software developer colleagues to find out where you stand.
                </p>
              </div>
            </div>
          </div>
          <div className="uk-section uk-text-center">
            <div className="tm-intro-image uk-padding-large uk-padding-remove-vertical">
              <div className="uk-inline">
                <img
                  src="/static/images/device-laptop.png"
                  width="960"
                  height="720"
                  alt="Laptop Device"
                />
                <div
                  style={{
                    position: 'absolute',
                    top: '5%',
                    left: '12%',
                    right: '12%',
                  }}
                >
                  <img src="/static/screenshots/quiz.png" alt="quiz screenshot" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="uk-cover-container uk-background-muted">
          <div className="uk-container">
            <div className="uk-section uk-margin-medium-bottom uk-padding-large uk-text-center">
              <h3>Asses Your Team's Secure Coding IQ</h3>
              <div>
                <Link data-test-id="assess-team-btn" to="/register" className="uk-button uk-button-primary uk-button-large tm-button-primary tm-button-large">
                  Assess Your Team Now!
                </Link>
              </div>
            </div>
          </div>
          <div className="uk-cover-container uk-background-secondary uk-padding-large uk-padding-remove-vertical uk-light">
            <div className="uk-container">
              <div className="uk-section uk-text-center uk-padding">
                <p>
                  Learn more about our Secure Development Training for Developers
                </p>
                <Link
                  data-test-id="learn-more-btn"
                  to="/secure-development-training"
                  className="uk-button uk-button-default uk-button-large"
                >
                  Learn More
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>
    )
  }
}


const mapStateToProps = state => ({
  isAuthenticated: state.auth.authenticationStatus === 'LOGGED_IN',
  quiz: state.quiz.quiz,
})

const mapDispatchToProps = dispatch => ({
  generateQuiz: () => { dispatch(generateQuiz()) },
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(QuizOverview))
